import { IAuditRequest } from '@/api/signup/interface';
import api from '@/api/signup';
import { delay } from './helpers';

const auditQueue: IAuditRequest[] = [];
let isOnline = true;

export const audit = (payload: IAuditRequest) => {
  auditQueue.push(payload);
  cleanQueue();
};

addEventListener(
  'online',
  () => {
    isOnline = true;
    cleanQueue();
  },
  { passive: true },
);

addEventListener(
  'offline',
  () => {
    isOnline = false;
  },
  { passive: true },
);

const cleanQueue = async (x: any = null) => {
  if (!isOnline) {
    return;
  }
  while (auditQueue.length > 0) {
    const a = auditQueue[0];
    await api
      .audit(a)
      .then(() => {
        auditQueue.shift();
      })
      .catch(() => {
        return delay(500).then(cleanQueue);
        // setTimeout(cleanQueue, 500);
      });
  }
};
